module.exports = __webpack_public_path__ + "media/components/country-flag/static/ye-b2e3181b4df9bf9835518b558c4d96d4.svg";